import { render } from "./JobsPage.vue?vue&type=template&id=fe04bfd8&scoped=true"
import script from "./JobsPage.vue?vue&type=script&lang=js"
export * from "./JobsPage.vue?vue&type=script&lang=js"

import "./JobsPage.vue?vue&type=style&index=0&id=fe04bfd8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe04bfd8"]])

export default __exports__